import { SelectItem } from 'primeng/api';
import { CustomerStatus } from '../../content/enums/organisation/customer-status';
import { OrganisationStatus } from '../../content/enums/organisation/organisation-status';
import { I18nService } from '../../core/services/i18n.service';

export class TableListProvider {

  /**
   * all provided select-lists
   * @private
   */
  providedLists: {[key: string]: SelectItem[]} = {};

  constructor(private i18n: I18nService) {
    this.initDefaultLists();
  }

  /**
   * Add new data-list, type = SelectItem-Array
   * @param key
   * @param listData
   */
  addListByKey(key: string, listData: SelectItem[]) {
    this.providedLists[key] = listData;
  }

  /**
   * fetch data-list by key
   * @param key
   */
  getListByKey(key: string): SelectItem[] {
    try {
      return this.providedLists[key];
    } catch (e) {
      return [];
    }
  }

  /**
   * initialize default data-lists
   * @private
   */
  private initDefaultLists() {
    /**
     * boolean-value as ja/nein
     */
    this.addListByKey(
      'BOOL_YES_NO',
      [
        { value: true, label: this.i18n.i18nLng()['YES'] },
        { value: false, label: this.i18n.i18nLng()['NO'] },
      ]
    );
    /**
     * boolean-vert as ja/nein, with null value as empty selection
     */
    this.addListByKey(
      'BOOL_YES_NO_NULL',
      [
        { value: null, label: ' '},
        { value: true, label: this.i18n.i18nLng()['YES'] },
        { value: false, label: this.i18n.i18nLng()['NO'] },
      ]
    );
    /**
     * sex selectItem
     */
    this.addListByKey(
      'SEX',
      [
        { value: 'n', label: this.i18n.i18nLng()['NOSEX'] },
        { value: 'm', label: this.i18n.i18nLng()['MALE'] },
        { value: 'w', label: this.i18n.i18nLng()['FEMALE'] },
        { value: 'd', label: this.i18n.i18nLng()['DIVERSE'] },
      ]
    );

    this.addListByKey(
      'PAYMENTCATEGORYICONS',
      [
        { value: 'pi pi-credit-card', label: 'pi pi-credit-card', title: 'CREDITCARD' },
        { value: 'creditcard_moto', label: 'creditcard_moto', title: 'CREDITCARD_MOTO' },
        { value: 'wero', label: 'wero', title: 'WERO' },
        { value: 'sepa', label: 'sepa', title: 'SEPA' },
        { value: 'sepa_blacklist', label: 'sepa_blacklist', title: 'SEPA_BLACKLIST' },
        { value: 'klarna', label: 'klarna', title: 'KLARNA' },
        { value: 'directtransfer', label: 'directtransfer', title: 'DIRECTTRANSFER' },
        { value: 'pi pi-paypal', label: 'pi pi-paypal', title: 'PAYPAL' },
        { value: 'pi pi-apple', label: 'pi pi-apple', title: 'APPLE' },
        { value: 'pi pi-google', label: 'pi pi-google', title: 'GOOGLE' },
      ]
    );
    this.addListByKey(
      'TRANSACTIONSTATUS',
      [
        { value: 'successful', label: this.i18n.i18nLng()['SUCCESSFUL'] },
        { value: 'canceled', label: this.i18n.i18nLng()['NOTSUCCESSFUL'] },
        { value: 'initialized', label: this.i18n.i18nLng()['INITIALIZED'] },
      ]
    );
    this.addListByKey(
      'TRANSACTIONTYPE',
      [
        { value: 'AUTH', label: this.i18n.i18nLng()['AUTHORIZATION'] },
        { value: 'CAPTURE', label: this.i18n.i18nLng()['CAPTURE'] },
        { value: 'CREDIT', label: this.i18n.i18nLng()['CHARGEBACK'] },
        { value: 'SALE', label: this.i18n.i18nLng()['SALE'] },
        { value: 'VOID', label: this.i18n.i18nLng()['VOID'] },
        { value: 'REFUND', label: this.i18n.i18nLng()['REFUND'] },
      ]
    );
    this.addListByKey(
      'PAYMENTTYPESTATUS',
      [
        { value: 'TEST', label: 'Test' },
        { value: 'LIVE', label: 'Live' },
        { value: 'CLOSED', label: this.i18n.i18nLng()['CLOSED'] },
      ]
    );
    this.addListByKey(
      'ACTIVATIONSTATUS',
      [
        { value: true, label: this.i18n.i18nLng()['ACTIVE'] },
        { value: false, label: this.i18n.i18nLng()['INACTIVE'] },
      ]
    );
    /**
     * iterate over OrganisationStatus-Enum and add
     * values and labels to the SelectItem for the
     * dropdown-filter in Onboarding (without CUSTOMER)
     * and for the status-selection (all status)
     */
    let orgaStatusList: SelectItem[] = [];
    Object.values(OrganisationStatus).forEach((item) => {
      orgaStatusList.push({
        value: item,
        label: this.i18n.i18nLng()['STATUS_' + item],
      })
    })
    this.addListByKey(
      'ORGASTATUS', orgaStatusList
    );
    this.addListByKey(
      'ORGASTATUSFILTER', orgaStatusList.filter(item => item.value !== OrganisationStatus.CUSTOMER)
    );
    /**
     * iterate over CustomerStatus-Enum and add
     * values and labels to the SelectItem for the
     * dropdown-filter
     */
    let customerStatusList: SelectItem[] = [];
    Object.values(CustomerStatus).forEach((item) => {
      customerStatusList.push({
        value: item,
        label: this.i18n.i18nLng()['C_STATUS_' + item],
      })
    })
    this.addListByKey(
      'CUSTOMERSTATUS', customerStatusList
    );

  }

}
